<script>
    export let name;
    export let size = 16;
    export let color = 'currentColor';
    export let strokeWidth = 1;
    export let cssClass = '';
</script>

<span class="svg-icon { cssClass }">
{#if name === 'menu'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
{:else if name === 'users'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
{:else if name === 'x'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
{:else if name === 'circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
    </svg>
{:else if name === 'plus-circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="16"></line>
        <line x1="8" y1="12" x2="16" y2="12"></line>
    </svg>
{:else if name === 'check'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
{:else if name === 'check-circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
{:else if name === 'chevron-up'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
{:else if name === 'chevron-down'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
{:else if name === 'chevron-left'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round"><polyline
            points="15 18 9 12 15 6"></polyline></svg>
{:else if name === 'chevron-right'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round"><polyline
            points="9 18 15 12 9 6"></polyline></svg>
{:else if name === 'caret-up'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 1792 1792" fill="{ color }">
        <path d="M1408 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"/>
    </svg>
{:else if name === 'caret-down'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 1792 1792" fill="{ color }">
        <path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/>
    </svg>
{:else if name === 'trash'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
{:else if name === 'refresh'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="1 4 1 10 7 10"></polyline>
        <polyline points="23 20 23 14 17 14"></polyline>
        <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
    </svg>
{:else if name === 'renew'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="23 4 23 10 17 10"></polyline>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
    </svg>
{:else if name === 'list'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
{:else if name === 'edit'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
    </svg>
{:else if name === 'save'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
        <polyline points="17 21 17 13 7 13 7 21"></polyline>
        <polyline points="7 3 7 8 15 8"></polyline>
    </svg>
{:else if name === 'search'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
{:else if name === 'key'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
    </svg>
{:else if name === 'book-open'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
{:else if name === 'gear'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
{:else if name === 'arrows-v'}
    <svg width="{ size }" height="{ size }" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"
         stroke-width="{ strokeWidth }" fill="{ color }">
        <path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"/>
    </svg>

{:else if name === 'clock'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
{:else if name === 'calendar'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
{:else if name === 'alert-circle'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
{:else if name === 'more-vertical'}
    <svg xmlns="http://www.w3.org/2000/svg" width="{ size }" height="{ size }" viewBox="0 0 24 24" fill="none"
         stroke="{ color }" stroke-width="{ strokeWidth }" stroke-linecap="round" stroke-linejoin="round"><circle
            cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle
            cx="12" cy="19" r="1"></circle>
    </svg>
{/if}
</span>

<style>
    .svg-icon {
        line-height: 1;
    }
</style>